"use client"

import { useEffect, useState } from "react"
import "./Contact.css"

const Contact = ({ language = "en" }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  // 🔹 Translations
  const translations = {
    en: {
      heroTitle: "Contact Hon. Abubakar Kabir Abubakar",
      heroDescription:
        "We welcome you to connect with us on social media for updates, announcements, and engagement with Bichi Federal Constituency. Your voice matters—reach out and stay involved!",
      socialTitle: "Follow Us",
      facebook: "Facebook",
      instagram: "Instagram",
      tiktok: "TikTok",
    },
    ha: {
      heroTitle: "Tuntuɓi Hon. Abubakar Kabir Abubakar",
      heroDescription:
        "Muna maraba da ku ku haɗa da mu a kafafen sada zumunta don samun sabuntawa, sanarwa, da hulɗa da Mazabar Tarayya ta Bichi. Muryarku tana da muhimmanci—ku tuntuɓe mu ku ci gaba da kasancewa cikin al'amura!",
      socialTitle: "Bi Mu",
      facebook: "Fesbuk",
      instagram: "Instagram",
      tiktok: "TikTok",
    },
  }

  const t = translations[language] || translations.en

  return (
    <div className="contact-container">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className={`hero-content ${isVisible ? "fade-in" : ""}`} style={{ textAlign: "center", margin: "0 auto" }}>
          <h1>{t.heroTitle}</h1>
          <p style={{ fontSize: "1.2rem", marginBottom: "2rem" }}>{t.heroDescription}</p>
        </div>
      </section>

      {/* Social Media Section */}
      <section className="contact-info">
        <div className="contact-grid">
          <div
            className={`contact-card ${isVisible ? "slide-in-up" : ""}`}
            style={{ width: "100%", textAlign: "center", margin: "0 auto" }}
          >
            <h2 style={{ marginBottom: "1rem" }}>{t.socialTitle}</h2>
            <div
              className="social-links"
              style={{ display: "flex", justifyContent: "center", gap: "2rem", marginTop: "2rem" }}
            >
              <a
                href="https://www.facebook.com/profile.php?id=100063653736192"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/facebook.png"
                  alt="Facebook"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                />
                <div style={{ marginTop: "0.5rem", fontWeight: "bold" }}>{t.facebook}</div>
              </a>

              <a
                href="https://www.instagram.com/hon_abubakar_bichi/?hl=en"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/instagram.png"
                  alt="Instagram"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                />
                <div style={{ marginTop: "0.5rem", fontWeight: "bold" }}>{t.instagram}</div>
              </a>

              <a
                href="https://www.tiktok.com/@honabubakarkabirabubakar?_t=ZS-904NjxMC7N4&_r=1"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/tiktok.png"
                  alt="TikTok"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                />
                <div style={{ marginTop: "0.5rem", fontWeight: "bold" }}>{t.tiktok}</div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact
